"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var types_1 = require("../lib/types");
function LostToBorSelector(props) {
    var value = props.value, onChange = props.onChange, _a = props.disabled, disabled = _a === void 0 ? false : _a, isRequired = props.isRequired, _b = props.defaultValue, defaultValue = _b === void 0 ? types_1.CLIENT_PREFERENCE_POLICY_LOSS_REASONS[0] : _b;
    var options = core_ui_1.stringsToOptions(__spreadArray(__spreadArray(__spreadArray([], types_1.CLIENT_PREFERENCE_POLICY_LOSS_REASONS), types_1.NF_UNABLE_TO_PLACE_RENEWAL_POLICY_LOSS_REASONS), types_1.PRODUCER_LEFT_NEWFRONT_POLICY_LOSS_REASONS));
    return (react_1.default.createElement(core_ui_1.SelectInput, { name: "Reason", options: options, onChange: function (option) {
            if (onChange)
                onChange(option);
        }, value: value, defaultValue: defaultValue, disabled: disabled, showSelectAnOption: !isRequired }));
}
exports.default = LostToBorSelector;
